/** Sample refs spelled differently in different places (quotes, case, runs of spaces) are one sample. */
export function _normSampleRef(r) {
  return String(r ?? '').replace(/^["']+|["']+$/g, '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export const normRef = (ref) => (typeof ref === 'string' ? ref.replace(/^["']+|["']+$/g, '').trim() : ref);

/**
 * The samples a run actually tests. The evidence map is only a fallback: it can hold leftover cells for
 * samples that were removed from the run (a copied run keeps its manual cells), which must not show up as
 * samples. Order of trust: the execution's own sample list, then the run's selected samples, then (for old
 * runs that have neither) the evidence map.
 */
export function resolveExpectedSamples(run, evidenceMap = []) {
  const ctx = run?.execution?.execution_context || {};
  const fromCtx = (ctx.samples || []).map((s) => normRef(s?.record_ref ?? s)).filter(Boolean);
  const fromRun = (run?.population_data?.selected_samples || []).map((s) => normRef(String(s))).filter(Boolean);
  const fromMap = (evidenceMap || []).map((c) => normRef(c.sample_ref)).filter(Boolean);
  const pick = fromCtx.length ? fromCtx : fromRun.length ? fromRun : fromMap;
  const seen = new Set();
  return pick.filter((r) => {
    const k = _normSampleRef(r);
    if (!k || seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
